import type { CountryCode } from "libphonenumber-js";

export function configuredDefaultCountry(code?: string, name?: string) {
  const country = (code?.trim().toUpperCase() || "SA") as CountryCode;
  return {
    code: country,
    name:
      name?.trim() ||
      (country === "SA"
        ? "Saudi Arabia"
        : country === "IN"
          ? "India"
          : country),
  };
}

export function configuredAvailableLocales(value?: string) {
  const configured = value
    ?.split(",")
    .map((locale) => locale.trim())
    .filter(Boolean);
  return configured?.length ? [...new Set(configured)] : ["en", "ar"];
}

export function configuredBusinessTimeZone(
  countryCode: string,
  value?: string,
) {
  return (
    value?.trim() ||
    (countryCode === "SA"
      ? "Asia/Riyadh"
      : countryCode === "IN"
        ? "Asia/Kolkata"
        : "")
  );
}

export function governmentOrganizationLabelKey(
  countryCode: string,
  type: string,
  index: number,
) {
  let labelType = type;
  if (countryCode === "SA") {
    if (type === "state") labelType = "region";
    else if (type === "default" && index === 0) return "location";
    else if (type === "default")
      labelType = ["country", "region", "city"][index] || "district";
  }
  if (labelType === "region") return "SYSTEM__govt_org_type__region";
  if (labelType === "city") return "SYSTEM__govt_org_type__city";
  return `SYSTEM__govt_org_type__${labelType}`;
}
